import { render, staticRenderFns } from "./DocumentResults.vue?vue&type=template&id=01e58d04"
import script from "./DocumentResults.vue?vue&type=script&lang=js"
export * from "./DocumentResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports